import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import suburbAutoCompleteActions from './suburb-auto-complete-actions'

/*

Simply provides suburb-auto-complete configuration to the wrapped components

*/

const mapStateToProps = (state, initialProps) => ({
    ...initialProps,
    suburbAutoComplete: state.suburbAutoComplete
})


const mapDispatchToProps = (dispatch, props) => ({
    actions:{
        ...props.actions,
        suburbAutoComplete: bindActionCreators( suburbAutoCompleteActions, dispatch )
    }
})


export const withSuburbAutoComplete = (Wrapped:React.ComponentClass) => connect(mapStateToProps, mapDispatchToProps)(Wrapped)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/suburb-auto-complete/index.tsx